"use client"

import { CloudSun } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CloudSunIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CloudSunIcon = component(Icon)({ as: CloudSun })
